import { render, staticRenderFns } from "./PostbackListItems.vue?vue&type=template&id=0ef1e054&scoped=true&"
import script from "./PostbackListItems.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PostbackListItems.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PostbackListItems.vue?vue&type=style&index=0&id=0ef1e054&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef1e054",
  null
  
)

export default component.exports